<template>
	<type-wrapper class="type-I" limit :bgUrl="showData.image">
		<type-grid row="1" v-if="showData.title" style="margin-top: 10px;">
			<type-title large>{{ showData.title }}</type-title>
		</type-grid>
		<type-grid row="1" v-if="showData.content" style="margin-bottom: 40px;">
			<type-content large center>{{ showData.content }}</type-content>
		</type-grid>
		<type-grid row="3" margin>
			<!-- <type-input :whitebackdrop="whitebackdrop" v-model="name" placeholder="尊姓大名"></type-input> -->
			<type-input :whitebackdrop="whitebackdrop" v-model="name" placeholder="Name"></type-input>
		</type-grid>
		<type-grid row="3" margin>
			<!-- <type-input :whitebackdrop="whitebackdrop" v-model="email" placeholder="邮箱地址"></type-input> -->
			<type-input :whitebackdrop="whitebackdrop" v-model="email" placeholder="Email"></type-input>
		</type-grid>
		<type-grid row="3" margin>
			<!-- <type-input :whitebackdrop="whitebackdrop" v-model="mobile"  :maxlength="mobileMaxlength" prefix placeholder="手机号码"> -->
			<type-input :whitebackdrop="whitebackdrop" v-model="mobile"  :maxlength="mobileMaxlength" prefix placeholder="Phone">
				<div slot="prefix" @click="changePre">{{ mobilePre }}</div>
			</type-input>
		</type-grid>
		<type-grid row="3" margin>
			<!-- <type-input :whitebackdrop="whitebackdrop" v-model="country" placeholder="国家"></type-input> -->
			<type-input :whitebackdrop="whitebackdrop" v-model="country" placeholder="Country"></type-input>
		</type-grid>
		<type-grid row="3" margin>
			<!-- <type-input :whitebackdrop="whitebackdrop" v-model="province" placeholder="省份"></type-input> -->
			<type-input :whitebackdrop="whitebackdrop" v-model="province" placeholder="Province"></type-input>
		</type-grid>
		<type-grid row="3" margin>
			<!-- <type-input :whitebackdrop="whitebackdrop" v-model="city" placeholder="城市"></type-input> -->
			<type-input :whitebackdrop="whitebackdrop" v-model="city" placeholder="City"></type-input>
		</type-grid>
		<type-grid row="23" margin>
			<!-- <type-input :whitebackdrop="whitebackdrop" v-model="address" placeholder="详细地址"></type-input> -->
			<type-input :whitebackdrop="whitebackdrop" v-model="address" placeholder="Address"></type-input>
		</type-grid>
		<type-grid row="3" margin>
			<!-- <type-input :whitebackdrop="whitebackdrop" v-model="zipCode" placeholder="邮编"></type-input> -->
			<type-input :whitebackdrop="whitebackdrop" v-model="zipCode" placeholder="Postcode"></type-input>
		</type-grid>
		<type-grid row="3" margin>
			<!-- <type-input :whitebackdrop="whitebackdrop" v-model="code" placeholder="暗号"></type-input> -->
			<type-input :whitebackdrop="whitebackdrop" v-model="code" placeholder="Coupon"></type-input>
		</type-grid>
		<type-grid row="3" margin>
			<!-- <type-input :whitebackdrop="whitebackdrop" v-model="quantity" prefix suffix placeholder="数量"> -->
			<type-input :whitebackdrop="whitebackdrop" v-model="quantity" prefix suffix placeholder="Number">
				<my-icon icon="minus" size="20px" color="#FFFFFF" slot="prefix" @click="changeNum(0)"></my-icon>
                <my-icon icon="plus" size="20px" color="#FFFFFF" slot="suffix" @click="changeNum(1)"></my-icon>
			</type-input>
		</type-grid>
		<type-grid row="3" margin>
			<toggle-register-or-login :value.sync="login" :whitebackdrop="whitebackdrop"></toggle-register-or-login>
		</type-grid>
		<type-grid row="1" margin>
			<!-- <type-textarea :whitebackdrop="whitebackdrop" v-model="notes" placeholder="留言"></type-textarea> -->
			<type-textarea :whitebackdrop="whitebackdrop" v-model="notes" placeholder="Message"></type-textarea>
		</type-grid>
		<type-grid row="1" margin>
			<!-- <type-button :whitebackdrop="whitebackdrop" border @click="placeOrder">下单</type-button> -->
			<type-button :whitebackdrop="whitebackdrop" border @click="placeOrder">Order</type-button>
		</type-grid>
	</type-wrapper>
</template>

<script>
	// 预购买框
	import mixin from '../mixin.js'
	import toggleRegisterOrLogin from './toggle-register-or-login.vue'
	export default {
		name: 'type-I',
		mixins: [ mixin ],
		data() {
			return {
				login: false,
				name: this.$userInfo.data.name || '',
				email: this.$userInfo.data.email || '',
				mobile: '',
				country: '',
				province: '',
				city: '',
				address: '',
				zipCode: '',
				code: '',
				quantity: '1',
				notes: '',
				mobilePre: '+1',
				mobileMaxlength: '10'
			}
		},
		methods: {
			changePre() {
				if (this.mobilePre === '+1') {
					this.mobilePre = '+86';
					this.mobileMaxlength = '11';
				} else {
					this.mobilePre = '+1';
					this.mobileMaxlength = '10';
					if (this.mobile.length > 10) {
						this.mobile = this.mobile.slice(0, 10);
					}
				}
			},
			changeNum(status) {
				if (isNaN(this.quantity)) {
					this.$message('请输入大于0的整数');
					return false;
				}
				const number = Number(this.quantity);
				if (status) {
					this.quantity = number + 1;
				} else {
					this.quantity = number > 1 ? (number - 1) : number;
				}
			},
			async placeOrder() {
				const data = {
					name: this.name,
					email: this.email,
					mobile: (this.mobilePre === '+1' ? '1' : '+86') + this.mobile,
					country: this.country,
					province: this.province,
					city: this.city,
					address: this.address,
					zipCode: this.zipCode,
					code: this.code,
					quantity: this.quantity,
					notes: this.notes
				};
				const result = this.$verify.verify(data);
				console.log('数据', JSON.parse(JSON.stringify(data)), '验证', JSON.parse(JSON.stringify(result)))
				if (result.tip) {
					this.$message(result.tip);
                    return;
				}
                const req = Object.create(null);
                req.is_single_product = '1';
                req.product_id = '1';
                // obj name
                req.product_name = this.showData.name;
                // obj tuwen的content内容
                req.product_description = this.showData.tuwen_content;
                req.product_json_string = '';
                req.quantity = this.quantity || '1';
                req.final_price = '1.00';
                req.currency = 'USD';
                req.origin = '1';
                req.customer_email = this.email;
                let address_json_string = {};
                address_json_string.country = this.country;
                address_json_string.province = this.province;
                address_json_string.city = this.city;
                address_json_string.address = this.address;
                address_json_string.phone = data.mobile;
                if (this.zipCode) {
                	address_json_string.zipCode = this.zipCode;
                }
                req.address_json_string = JSON.stringify(address_json_string);
                req.receiver_name = this.name;
                req.coupon_id_used = '1';
                req.payment_channel = 'stripe';
                req.object_id = this.typeData.object_id;
                req.seller_user_id = this.typeData.data.user_id || '2';
                req.buyer_user_id = this.$userInfo.data.user_id || '2';
                req.is_digital = '0';
                req.success_url = window.location.href.split('&')[0];
                req.cancel_url = window.location.href.split('&')[0];
                if (this.notes) {
                	req.notes = this.notes;
                }
                if (this.login) {
                    const { status, data } = this.$getUserInfo('register');
                    if (status === 'close') {
                        return;
                    }
                }
                console.log('下单数据', JSON.parse(JSON.stringify(req)))
                const orderResult = await this.$http.order.add(req);
                if (orderResult.status !== 'success') {
                    return;
                }
                console.log('订单数据', JSON.parse(JSON.stringify(orderResult.data)))
                const stripe = Stripe(this.$config.STRIPE_KEY);
                const stripeResult = await stripe.redirectToCheckout({ sessionId: orderResult.data.stripe_session_id });
                console.log('支付结果', JSON.parse(JSON.stringify(stripeResult)))
                if (stripeResult.error && stripeResult.error.code) {
                    this.$message('下单失败');
                }
                // const that = this;
                // const stripe = Stripe(this.$config.STRIPE_KEY);
                // stripe.redirectToCheckout({ sessionId: orderResult.data.stripe_session_id }).then(function (result) {
                // 	// {
                // 	// 	"error": {
                // 	// 		"code": "redirect_error",
                // 	// 		"message": "Failed to redirect to https://checkout.stripe.com/pay/cs_test_tqRbiZrSsljcjBC8a35EUJOEqBhRQt1MqznfjNRQrFO1Ph1cdHskGqyL#fidkdWxOYHwnPyd1blpxYHZxWjJtVndDbk1hYWBnTm5US3AzZ19Ec0lgfzU1S1JPVWR0dG8nKSd3YGNgd3dgd0p3bGJsayc%2Fa3BpaSknaGxhdic%2FfidicGxhJz8nS0QnKSdocGxhJz8nZ2E0YGBmPTMoZGNkZigxNmRmKGc8PDAoZzxnZ2Q8ZmZgPWQ2JykndmxhJz8nYzFmNGRjMDEoYGc8MygxNDczKD1mMmAoNTM8PT1nYTc0MzcxJ3gpJ2dgcWR2Jz9eWHgl"
                // 	// 	}
                // 	// }
                // 	// console.log(result);
                // 	if (result.error && result.error.code) {
                // 		that.$message('下单失败');
                // 		return false;
                // 	}
                // });
			}
		},
		components: {
			'toggle-register-or-login': toggleRegisterOrLogin
		}
	}
</script>

<style scoped lang="less">
	.type-I{}
</style>
